import { render } from "./BasicInformation.vue?vue&type=template&id=9b06b2ce&scoped=true&ts=true"
import script from "./BasicInformation.vue?vue&type=script&lang=ts"
export * from "./BasicInformation.vue?vue&type=script&lang=ts"

import "./BasicInformation.vue?vue&type=style&index=0&id=9b06b2ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b06b2ce"]])

export default __exports__